import { useState } from "react";
import { Play } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { trackEvent } from "@/lib/track";

const VIDEOS = [
  { n: "VIDEO 01", title: "Meet Dr. Santhisree Bheesetti", img: "/award.jpg", pos: "center 30%", embed: "0QgPs-IsAGc" },
  { n: "VIDEO 02", title: "Understanding Your Child's Individual Needs", img: "/marma-forehead.jpg", pos: "center 40%", embed: "7aMVNDIl-Oc" },
  { n: "VIDEO 03", title: "What to Expect During Your USA Consultation", img: "/marma-hands.jpg", pos: "center 45%", embed: "P97zlMY4huk" },
];

export default function Videos() {
  const [active, setActive] = useState(null);

  const onPlay = (i, v) => {
    trackEvent("VideoPlay", { video: v.title });
    setActive(i);
  };

  return (
    <section id="videos" data-testid="videos-section" className="bg-[#1B3B2B] py-16 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <Eyebrow light>
            <span className="mx-auto">Chapter 08 · Watch</span>
          </Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#FAF7F2] tracking-tight">
            Hear From Dr. Santhisree
          </h2>
          <p className="mt-4 text-base text-[#FAF7F2]/70">
            Learn more about her approach, the consultation process and how personalized Ayurvedic care works.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {VIDEOS.map((v, i) => (
            <Reveal key={v.n} delay={i * 0.12}>
              <div className="group w-full text-left">
                <div className="relative aspect-video rounded-3xl overflow-hidden bg-[#132C20] border border-[#C5A059]/25 group-hover:border-[#C5A059]/60 transition-colors duration-500">
                  {active === i ? (
                    <iframe
                      data-testid={`video-iframe-${i + 1}`}
                      src={`https://www.youtube.com/embed/${v.embed}?autoplay=1&rel=0`}
                      title={v.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="absolute inset-0 h-full w-full"
                    />
                  ) : (
                    <button
                      data-testid={`video-card-${i + 1}`}
                      onClick={() => onPlay(i, v)}
                      className="absolute inset-0 w-full h-full cursor-pointer"
                      aria-label={`Play video: ${v.title}`}
                    >
                      <img
                        src={v.img}
                        alt={v.title}
                        loading="lazy"
                        className="absolute inset-0 h-full w-full object-cover opacity-80 group-hover:opacity-95 group-hover:scale-105 transition-all duration-700"
                        style={{ objectPosition: v.pos }}
                      />
                      <span className="absolute inset-0 bg-gradient-to-t from-[#132C20]/80 via-[#132C20]/20 to-transparent" />
                      <span className="absolute inset-0 flex items-center justify-center">
                        <span className="w-16 h-16 rounded-full bg-[#C5A059]/95 flex items-center justify-center animate-pulse-ring group-hover:scale-110 transition-transform duration-500">
                          <Play className="w-6 h-6 text-[#1B3B2B] fill-[#1B3B2B] ml-0.5" />
                        </span>
                      </span>
                    </button>
                  )}
                </div>
                <p className="mt-4 text-[11px] font-semibold tracking-[0.24em] uppercase text-[#C5A059]">{v.n}</p>
                <p className="mt-1.5 font-serif text-xl text-[#FAF7F2] leading-snug">{v.title}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
